import { get } from 'src/axios/post'
import { reset, wait } from 'src/store'

const loggedInStates = () => {
  return [
    'notifications',
    'loading',
    'notifications_granted'
  ]
}

const defaultStates = () => {
  return {
    notifications: [],
    needsReloading: true,
    loading: false,
    notifications_granted: false
  }
}

export default {
  namespaced: true,
  state: defaultStates(),
  mutations: {
    reset (state) {
      reset(state, loggedInStates(), defaultStates())
    },
    setLoading (state, val) {
      state.loading = Boolean(val)
    },
    setNeedsReloading (state, val) {
      state.needsReloading = Boolean(val)
    },
    setNotifications (state, notifications) {
      const currentIds = state.notifications.map(item => item.id)
      state.notifications.unshift(...notifications.filter(item => !currentIds.includes(item.id)))
    },
    markAsRead (state, id) {
      const notif = state.notifications.find(item => item.id === id)
      if (notif) {
        notif.is_read = true
      }
    },
    deleteNotification (state, ids) {
      for (const id of ids) {
        const index = state.notifications.map(item => item.id).indexOf(id)
        if (index > -1) {
          state.notifications.splice(index, 1)
        }
      }
    },
    setNotificationsGranted (state, val) {
      state.notifications_granted = Boolean(val)
    }
  },
  actions: {
    async getNotifications ({ commit, state }) {
      if (state.loading || !state.needsReloading) {
        if (state.loading) {
          await wait(state, 'loading')
        }
        return
      }
      commit('setNeedsReloading', false)
      commit('setLoading', true)
      const { status, payload } = await get('v1/notifications/all')
      commit('setLoading', false)
      if (status === 'success') {
        commit('setNotifications', payload.notifications || [])
      }
    }
  },
  getters: {
    getNotifications: state => state.notifications,
    isLoading: state => state.loading,
    getUnreadCount: state => state.notifications.filter(item => !item.is_read).length,
    getReadCount: state => state.notifications.filter(item => item.is_read).length,
    hasGrantedNotifications: state => state.notifications_granted
  }
}
